import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './Container';
import { footerColumns, site, socialLinks } from '../data/site';
export function Footer() {
  return <footer className="border-t border-hairline bg-canvas" data-id="element-386" data-mp="32o4ao9g4a660">
      <Container data-id="element-387" data-mp="32pp4txyirn3c">
        <div className="grid grid-cols-2 gap-x-8 gap-y-12 py-16 lg:grid-cols-4 lg:py-24" data-id="element-388" data-mp="32m1cv38q38qq">
          {footerColumns.map(column => <div key={column.title} data-id="element-389" data-mp="3uesani6215i3">
              <h2 className="text-small font-semibold text-ink" data-id="element-390" data-mp="3uftmvpyt3y1e">{column.title}</h2>
              <ul className="mt-5 space-y-3" data-id="element-391" data-mp="37fun6gwqy3r">
                {column.links.map(link => <li key={`${column.title}-${link.label}`} data-id="element-392" data-mp="3ldkd52bd48p2">
                    <Link to={link.to} className="text-small text-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-393" data-mp="3qd6sbhar3z0i">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}

          <div data-id="element-394" data-mp="3labt60db0esh">
            <h2 className="text-small font-semibold text-ink" data-id="element-395" data-mp="3l9sin4pzgsoh">Contact</h2>
            <ul className="mt-5 space-y-3 text-small text-muted" data-id="element-396" data-mp="3gbqzykwgyvdj">
              <li data-id="element-397" data-mp="3v89cqak7xner">
                <a href={`mailto:${site.email}`} className="transition-colors duration-150 ease-out hover:text-ink" data-id="element-398" data-mp="3v8rhjvky59ya">
                  {site.email}
                </a>
              </li>
              <li data-id="element-399" data-mp="80xjc6sbqxik">
                <a href={site.phoneHref} className="transition-colors duration-150 ease-out hover:text-ink" data-id="element-400" data-mp="33xe1y3atysi">
                  {site.phone}
                </a>
              </li>
              <li className="max-w-[24ch] pt-2 leading-6" data-id="element-401" data-mp="ctgyh86nu0ph">{site.location}</li>
            </ul>
          </div>

          <div data-id="element-402" data-mp="qujjriptz6zc">
            <h2 className="text-small font-semibold text-ink" data-id="element-403" data-mp="qu1fbyt0lmgc">Elsewhere</h2>
            <ul className="mt-5 space-y-3" data-id="element-404" data-mp="msy11gqm7yh8">
              {socialLinks.map(link => <li key={link.label} data-id="element-405" data-mp="tvw5sbdtv5dc">
                  <a href={link.to} target="_blank" rel="noopener noreferrer" className="text-small text-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-406" data-mp="twxu3hjutod0">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-hairline py-8 text-small text-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-407" data-mp="1clcli5y334ec">
          <p data-id="element-408" data-mp="1mj8uar3jtn9a">
            © {new Date().getFullYear()} {site.name}
          </p>
          <p data-id="element-409" data-mp="1riv56tvwmrex">{site.locationShort}</p>
        </div>
      </Container>
    </footer>;
}